export const mainColor = "#E8433A";
export const mainBlack = "#010101";
export const bgBlack = "#150f0f";
export const fontWhite = "#e6e6e6";
export const fontHeading = "#f4f4f4";
export const yellow = "#ffc500";
export const grey = "#cccccc";
